export default __webpack_public_path__ + "static/media/jacket.13907b2a.svg";